// Anuva product page: gallery, price/options, buy flow, sticky bar, toast, pincode, size guide.
(() => {
  if (window.__anuvaProduct) return;
  window.__anuvaProduct = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const root = window.Shopify?.routes?.root || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  const fmt = (cents, trim) =>
    'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: trim ? 0 : 2, maximumFractionDigits: trim ? 0 : 2 });

  /* ---------- Gallery ---------- */
  const initGallery = (gallery) => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = $('[data-anuva-track]', gallery);
    const slides = $$('.anuva-pg__slide', track);
    const thumbs = $$('[data-anuva-thumb]', gallery);
    const dots = $$('.anuva-pg__dot', gallery);
    const current = $('[data-anuva-current]', gallery);
    let index = 0;

    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, n) => t.toggleAttribute('aria-current', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      if (current) current.textContent = i + 1;
    };

    const goTo = (i) => {
      if (!slides.length) return;
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
      setActive(n);
    };

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) setActive(i);
      });
    });

    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-anuva-thumb]');
      if (thumb) return goTo(Number(thumb.dataset.anuvaThumb));
      if (e.target.closest('[data-anuva-prev]')) return goTo(index - 1);
      if (e.target.closest('[data-anuva-next]')) return goTo(index + 1);
    });

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    const onVariant = (e) => {
      const id = e.detail?.resource?.featured_media?.id;
      if (!id) return;
      const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i >= 0) goTo(i);
    };
    document.addEventListener('variant:update', onVariant);
    document.addEventListener('anuva:variant', onVariant);
  };

  /* ---------- Badges + stock follow the selected variant ---------- */
  const syncSave = (variant) => {
    const diff = variant && variant.compare_at_price > variant.price ? variant.compare_at_price - variant.price : 0;
    $$('[data-anuva-save]').forEach((badge) => {
      badge.hidden = diff <= 0;
      if (diff > 0) badge.textContent = `Save ${fmt(diff, true)}`;
    });
    $$('[data-anuva-gallery-badge]').forEach((badge) => {
      const pct = diff > 0 ? Math.round((diff / variant.compare_at_price) * 100) : 0;
      badge.hidden = pct <= 0;
      if (pct > 0) badge.textContent = `${pct}% off`;
    });
  };

  const syncStock = (variant) => {
    const note = $('[data-anuva-stock]');
    if (!note || !variant) return;
    let stock = {};
    try { stock = JSON.parse(note.dataset.stock || '{}'); } catch (e) {}
    const qty = stock[variant.id];
    const show = typeof qty === 'number' && qty > 0 && qty <= Number(note.dataset.threshold || 5);
    note.hidden = !show;
    if (show) $('[data-anuva-stock-qty]', note).textContent = qty;
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const showToast = (text) => {
    const toast = $('[data-anuva-toast]');
    if (!toast) return;
    $('[data-anuva-toast-text]', toast).textContent = text;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-open'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove('is-open');
      setTimeout(() => (toast.hidden = true), 300);
    }, 2800);
  };

  /* ---------- Product information ---------- */
  const initInfo = (pi) => {
    if (pi.dataset.ready) return;
    pi.dataset.ready = 'true';
    let variants = [];
    try { variants = JSON.parse($('[data-anuva-variants]')?.textContent || '[]'); } catch (e) {}
    const mainAdd = $('[data-anuva-add-main]', pi);
    const qtyInput = $('[data-anuva-qty-input]', pi);
    const urlVariant = new URL(location.href).searchParams.get('variant');
    let variant =
      variants.find((v) => String(v.id) === urlVariant) ||
      variants.find((v) => String(v.id) === mainAdd?.dataset.variantId) ||
      variants[0];

    const fieldsets = () => $$('[data-anuva-option]', pi);
    const selected = () => fieldsets().map((fs) => $('input:checked', fs)?.value ?? null);
    const findVariant = (sel) => variants.find((v) => v.options.every((o, n) => sel[n] == null || o === sel[n]));

    const updateValueStates = () => {
      const sel = selected();
      fieldsets().forEach((fs, i) => {
        $$('input', fs).forEach((input) => {
          const trial = [...sel];
          trial[i] = input.value;
          const match = findVariant(trial);
          input.closest('.anuva-pi__value').classList.toggle('is-unavailable', !match || !match.available);
        });
        const label = $('[data-anuva-option-value]', fs);
        if (label) label.textContent = sel[i] ?? 'Select';
      });
    };

    const render = () => {
      if (!variant) return;
      const sale = variant.compare_at_price > variant.price;
      $$('[data-anuva-price]').forEach((el) => { el.textContent = fmt(variant.price); el.classList.toggle('is-sale', sale); });
      $$('[data-anuva-compare]').forEach((el) => { el.textContent = fmt(variant.compare_at_price || 0); el.hidden = !sale; });
      $$('[data-anuva-sticky-price]').forEach((el) => { el.textContent = fmt(variant.price, true); el.classList.toggle('is-sale', sale); });
      $$('[data-anuva-sticky-compare]').forEach((el) => { el.textContent = fmt(variant.compare_at_price || 0, true); el.hidden = !sale; });
      syncSave(variant);
      syncStock(variant);
      $$('[data-anuva-add-main], [data-anuva-add-sticky]').forEach((btn) => {
        btn.disabled = !variant.available;
        btn.dataset.variantId = variant.id;
        $('[data-anuva-add-label]', btn).textContent = variant.available ? 'Add to bag' : 'Sold out';
      });
      const buyNow = $('[data-anuva-buy-now]', pi);
      if (buyNow) buyNow.hidden = !variant.available;
      updateValueStates();
    };

    // Reflect a ?variant= URL in the option inputs.
    if (variant && fieldsets().length) {
      fieldsets().forEach((fs, i) => {
        $$('input', fs).forEach((input) => (input.checked = input.value === variant.options[i]));
      });
    }

    pi.addEventListener('change', (e) => {
      if (!e.target.closest('[data-anuva-option]')) return;
      const match = findVariant(selected());
      if (!match) return updateValueStates();
      variant = match;
      render();
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('anuva:variant', { detail: { resource: variant } }));
    });

    pi.addEventListener('click', (e) => {
      const step = e.target.closest('[data-anuva-qty]');
      if (!step || !qtyInput) return;
      qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + Number(step.dataset.anuvaQty));
    });

    const optionSummary = () => {
      if (!variant || variant.title === 'Default Title' || !fieldsets().length) return '';
      const names = fieldsets().map((fs) => $('.anuva-pi__option-label .anuva-pi__mobile', fs)?.textContent.trim() || '');
      return ' · ' + variant.options.map((o, i) => `${names[i] ? names[i] + ' ' : ''}${o}`).join(', ');
    };

    const addToBag = async () => {
      if (!variant?.available) return;
      const qty = Math.max(1, Number(qtyInput?.value) || 1);
      const buttons = $$('[data-anuva-add-main], [data-anuva-add-sticky]');
      buttons.forEach((b) => b.classList.add('is-loading'));
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] }),
        });
        if (!res.ok) {
          let message = 'Could not add to bag';
          try { message = (await res.json()).description || message; } catch (e) {}
          throw new Error(message);
        }
        const cart = await (await fetch(`${root}cart.js`)).json();
        const inBag = cart.items.filter((i) => i.variant_id === variant.id).reduce((n, i) => n + i.quantity, 0);
        // Update the header bag count without opening the cart drawer; the toast confirms instead.
        try {
          const { CartAddEvent } = await import('@theme/events');
          const drawer = document.querySelector('cart-drawer-component[auto-open]');
          drawer?.removeAttribute('auto-open');
          document.dispatchEvent(new CartAddEvent(cart, 'anuva-product', { itemCount: cart.item_count, variantId: String(variant.id), source: 'anuva-product' }));
          setTimeout(() => drawer?.setAttribute('auto-open', ''), 0);
        } catch (e) {}
        buttons.forEach((b) => ($('[data-anuva-add-label]', b).textContent = `Add another · ${inBag} in bag`));
        showToast(`Added to bag${optionSummary()}`);
      } catch (err) {
        showToast(err.message || 'Could not add to bag');
      } finally {
        buttons.forEach((b) => b.classList.remove('is-loading'));
      }
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-anuva-add-main], [data-anuva-add-sticky]')) return addToBag();
      if (e.target.closest('[data-anuva-buy-now]') && variant?.available) {
        const qty = Math.max(1, Number(qtyInput?.value) || 1);
        location.href = `${root}cart/${variant.id}:${qty}`;
      }
    });

    // Mobile sticky bar: visible once the main buy row has scrolled above the viewport.
    const stickyBar = $('[data-anuva-sticky]');
    const buyRow = $('[data-anuva-buy]', pi);
    if (stickyBar && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', String(!show));
        const btn = $('[data-anuva-add-sticky]', stickyBar);
        if (btn) btn.tabIndex = show ? 0 : -1;
        document.documentElement.classList.toggle('anuva-sticky-bar', show);
      }).observe(buyRow);
    }

    if (matchMedia('(min-width: 750px)').matches) $$('[data-desktop-open]', pi).forEach((d) => (d.open = true));

    render();
  };

  /* ---------- Copy discount code ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-anuva-copy]');
    if (!btn) return;
    const code = btn.dataset.anuvaCopy;
    try {
      await navigator.clipboard.writeText(code);
    } catch (err) {
      const input = Object.assign(document.createElement('input'), { value: code });
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    const original = btn.innerHTML;
    btn.textContent = 'Copied';
    btn.classList.add('is-copied');
    setTimeout(() => { btn.innerHTML = original; btn.classList.remove('is-copied'); }, 1800);
  });

  /* ---------- Pincode (uses the store's deliverable pincode list) ---------- */
  let pincodesLoading;
  const loadPincodes = (form) => {
    if (window.deliverablePincodes) return Promise.resolve();
    if (!pincodesLoading) {
      pincodesLoading = new Promise((resolve) => {
        const s = document.createElement('script');
        s.src = form.dataset.pincodes;
        s.onload = s.onerror = resolve;
        document.head.appendChild(s);
      });
    }
    return pincodesLoading;
  };
  document.addEventListener('focusin', (e) => {
    const form = e.target.closest?.('[data-anuva-pin]');
    if (form) loadPincodes(form);
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-anuva-pin]');
    if (!form) return;
    e.preventDefault();
    const pin = $('[data-anuva-pin-input]', form).value.trim();
    const result = form.parentElement.querySelector('[data-anuva-pin-result]');
    const set = (text, state) => {
      result.textContent = text;
      result.className = 'anuva-pi__pin-result' + (state ? ` is-${state}` : '');
    };
    if (!/^\d{6}$/.test(pin)) return set('Please enter a valid 6-digit pincode.', 'error');
    set('Checking…');
    await loadPincodes(form);
    const list = window.deliverablePincodes;
    if (Array.isArray(list) && !list.includes(pin)) return set('Sorry, we don’t deliver to this pincode yet.', 'error');
    const d = new Date();
    d.setDate(d.getDate() + 4);
    const date = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    set(`Delivery to ${pin} by ${date} · Cash on delivery available`, 'ok');
  });

  /* ---------- Size guide ---------- */
  let guideTrigger;
  const guide = () => [$('#AnuvaSizeGuide'), $('[data-anuva-guide-overlay]')];
  const openGuide = (trigger) => {
    const [sheet, overlay] = guide();
    if (!sheet || !overlay) return;
    [sheet, overlay].forEach((el) => {
      if (el.parentElement !== document.body) document.body.appendChild(el);
      el.hidden = false;
    });
    guideTrigger = trigger;
    requestAnimationFrame(() => { sheet.classList.add('is-open'); overlay.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('.anuva-guide__close', sheet)?.focus(), 50);
  };
  const closeGuide = () => {
    const [sheet, overlay] = guide();
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { sheet.hidden = overlay.hidden = true; }, 400);
    guideTrigger?.focus();
  };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-anuva-open-guide]');
    if (t) return openGuide(t);
    if (e.target.closest('[data-anuva-close-guide], [data-anuva-guide-overlay]')) closeGuide();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeGuide(); });

  const init = () => {
    $$('[data-anuva-gallery]').forEach(initGallery);
    $$('[data-anuva-pi]').forEach(initInfo);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
